import { FamilyMemberInsurancePolicy } from 'core'

import { Alert, Button, Col, Icon, Row } from 'common/components'
import { calculateDays, formatYearV2 } from 'common/dateFormatters'

import { DependentToEdit } from '..'

type Props = {
  firstName: string
  lastName: string
  isCoveredForTheFullYear: boolean
  familyMemberInsurancePolicies: FamilyMemberInsurancePolicy[]
  hasMultiplePolicies: boolean
  onEdit: (policy: DependentToEdit) => void
  onRemove: (id: string) => void
}

const Content = ({
  firstName,
  lastName,
  isCoveredForTheFullYear,
  familyMemberInsurancePolicies,
  hasMultiplePolicies = false,
  onEdit,
  onRemove,
}: Props) => {
  const currentYear = new Date().getFullYear()
  const isDuringCurrentYear = Number(formatYearV2(familyMemberInsurancePolicies[0].endDate)) >= currentYear

  const earliestStartDate = familyMemberInsurancePolicies.reduce((acc, item) => {
    if (item.startDate < acc) return item.startDate
    return acc
  }, familyMemberInsurancePolicies[0].startDate)

  const latestEndDate = familyMemberInsurancePolicies.reduce((acc, item) => {
    if (item.endDate > acc) return item.endDate
    return acc
  }, familyMemberInsurancePolicies[0].endDate)

  const isCoveredForMultiplePolociesForFullYear = calculateDays(earliestStartDate, latestEndDate) >= 364

  const statusAlert = (() => {
    if (isCoveredForTheFullYear || isCoveredForMultiplePolociesForFullYear)
      return (
        <Alert
          className="w-100 mt-4"
          showIcon
          type="success"
          message="This person is fully covered for 2024 Benefit year."
        />
      )

    return (
      <Alert
        className="w-100 mt-4"
        showIcon
        type="warning"
        message="This person is partly covered for 2024 Benefit year."
      />
    )
  })()

  return (
    <>
      <Row>
        <Col span={12}>
          <>
            <p className="gray-7">First Name</p>
            <p>{firstName}</p>
          </>
        </Col>
        <Col span={12}>
          <>
            <p className="gray-7">Last Name</p>
            <p>{lastName}</p>
          </>
        </Col>
      </Row>
      <Row>
        <p className="gray-7">Health Insurance Plan Coverage</p>
        <div className="gap-8 grid w-100 mb-16">
          {familyMemberInsurancePolicies.map((item) => (
            <Row key={item.id} className="flex flex_space_between flex__align_center">
              <span>{item.policyName}</span>
              {hasMultiplePolicies && (
                <div className="flex">
                  <Button
                    onClick={(e) => {
                      e.stopPropagation()
                      onEdit(item)
                    }}
                  >
                    <Icon type="far fa-pencil-alt" fontAwesome />
                  </Button>

                  <Button
                    className="ml-8"
                    danger
                    onClick={(e) => {
                      e.stopPropagation()
                      onRemove(item.id)
                    }}
                  >
                    <Icon className={'fal fa-trash-alt'} />
                  </Button>
                </div>
              )}
            </Row>
          ))}
        </div>
      </Row>
      {isDuringCurrentYear && <Row>{statusAlert}</Row>}
    </>
  )
}

export default Content
